import { useRef, useState } from 'react'
import {
    queryGoodsPlatformPerfectExpireCount,
    queryPlatformShelvesFailCount,
    getGoodsPlatformPerfectExpireTaskInfo,
    startCheckGoodsPlatformPerfectExpireTask
} from '@/services/goods'
import { poll } from '@/utils/utils'
import {
    PERFECT_TYPE_OPTION,
    TASK_STATUS_RUNNING,
    FAIL_TYPE_END
} from '@/modules/goods/constants/perfectExpirePlatform'

export default () => {
    const $this = useRef({
        pollExec: null
    })

    const [option, setOption] = useState(() => {
        return PERFECT_TYPE_OPTION.map(item => ({
            ...item,
            num: 0
        }))
    })
    const [taskStatus, setTaskStatus] = useState(null)
    const [curProcess, setCurProcess] = useState(null)
    const [invalidCatePropEnabled, setInvalidCatePropEnabled] = useState(false) // 是否可以批量完善

    const initCount = async () => {
        const [expireCountJson, failCountJson] = await Promise.all([
            queryGoodsPlatformPerfectExpireCount(),
            queryPlatformShelvesFailCount()
        ])

        let option = [...PERFECT_TYPE_OPTION]

        if (expireCountJson.success) {
            const expireData = expireCountJson.data

            option = option.map(item => {
                const key = item.key

                if (typeof expireData[key] !== 'undefined') {
                    return {
                        ...item,
                        num: expireData?.[key] || 0
                    }
                }

                return item
            })
        }

        if (failCountJson.success) {
            const failData = failCountJson.data

            option = option.map(item => {
                if (item.key.indexOf(FAIL_TYPE_END) > 0) {
                    const key = item.key.replace(FAIL_TYPE_END, '')
                    return {
                        ...item,
                        num: failData?.[key] || 0
                    }
                }

                return item
            })
        }

        setOption(option)
    }

    const initTaskInfo = () => {
        $this.current.pollExec && $this.current.pollExec()

        $this.current.pollExec = poll(
            async next => {
                const taskInfoJson = await getGoodsPlatformPerfectExpireTaskInfo()

                if (taskInfoJson.success) {
                    const taskStatus = taskInfoJson?.data?.taskStatus
                    setTaskStatus(taskStatus)
                    setCurProcess(taskInfoJson?.data?.progressInfo?.curProcess || 0)
                    setInvalidCatePropEnabled(taskInfoJson?.data?.invalidCatePropEnabled)

                    if (taskStatus === TASK_STATUS_RUNNING) {
                        next()
                    } else {
                        initCount()
                    }
                }
            },
            { immediately: false, duration: 1500 }
        )
    }

    const onBegin = async () => {
        await startCheckGoodsPlatformPerfectExpireTask()
        await initTaskInfo()
    }

    const init = () => {
        initTaskInfo()
        initCount()
    }

    return {
        init,
        onBegin,
        initCount,
        option,
        taskStatus,
        curProcess,
        invalidCatePropEnabled
    }
}
